import {Component, inject, OnInit} from '@angular/core';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';
import {GrupoService} from '../shared/service/grupo.service';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {Grupo} from '../shared/model/grupo/grupo.model';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {MatDialog} from '@angular/material/dialog';
import {
  ModalCadastroVisualizacaoGrupoComponent
} from './modal-cadastro-visualizacao-grupo/modal-cadastro-visualizacao-grupo.component';
import {MsgService} from '../shared/service/msg.service';
import {environment} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {AuthService} from '../shared/service/auth.service';
import {UsuarioResumo} from '../shared/model/usuario/usuario-resumo-model';
import {DatePipe} from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';

@Component({
  selector: 'app-grupo',
  standalone: true,
  imports: [
    TituloRotinaComponent,
    MatTableModule,
    ButtonPadraoComponent,
    FormFieldComponent,
    DatePipe,
    MatTooltipModule
  ],
  templateUrl: './grupo.component.html',
  styleUrl: './grupo.component.css'
})
export class GrupoComponent implements OnInit {

  grupos: Grupo[] = [];
  gruposDataSource = new MatTableDataSource<Grupo>();
  gruposCarregados = false;
  displayedColumns: string[] = ['acao', 'logo', 'nome', 'nomeResponsavel', 'emailResponsavel', 'qtdUsuario', 'ativo', 'usuCriacao', 'dataCriacao', 'usuAlteracao', 'dataAlteracao'];

  listaUsuarios: UsuarioResumo[] = [];

  private readonly grupoService = inject(GrupoService);
  private readonly dialog = inject(MatDialog);
  private readonly msgService = inject(MsgService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.buscarGrupos();
  }

  buscarGrupos() {
    this.grupoService.buscarGrupos().subscribe({
      next: res => {
        this.gruposCarregados = false;
        this.grupos = res;
        this.gruposDataSource = new MatTableDataSource(this.grupos);
      },
      complete: () => {
        this.gruposCarregados = true;
      }
    });
  }

  abrirModal(visualizar: boolean, grupo?: Grupo) {
    const grupoEnvio = {...grupo};
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoGrupoComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: {
        visualizar,
        grupo: grupoEnvio,
        listaUsuarios: this.listaUsuarios
      },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    })

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) {
          dialogRef.close();
        }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.grupoService.salvarGrupo(res).subscribe({
            next: () => {
              this.buscarGrupos();
              this.msgService.msgSucesso('Sucesso ao salvar grupo');
            }
          });
        }
      }
    });
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

  filtrarGrupos(filtro: string) {
    this.gruposDataSource.data = this.grupos.filter(gru => gru.nome!.toLowerCase().includes(filtro.toLowerCase()));
  }
}
